import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// antd
import { Row, Typography } from 'antd'

// assets
import { FileAddIcon } from '../../../assets/icons'

// slices
import { supportState } from './support.slice'

// styles
import MediaViewer from '../components/mediaViewer'

const SupportAttachmentSection = () => {
    const { Title } = Typography

    const { selectedTask } = useSelector(supportState)

    const [fileURL, setFileURL] = useState([])

    useEffect(() => {
        if (selectedTask?.attachment) {
            setFileURL(selectedTask?.attachment)
        } else {
            setFileURL([])
        }
    }, [selectedTask])

    return (
        <>
            <div
                style={{
                    marginTop: '20px',
                }}
            >
                <Row
                    align={'middle'}
                    style={{
                        columnGap: '6px',
                        width: '100%',
                    }}
                >
                    <FileAddIcon />
                    <Title className="titleSub">Files</Title>
                </Row>
                <Row
                    style={{
                        width: '100%',
                        flexFlow: 'inherit',
                        marginTop: '20px',
                        columnGap: '10px',
                        rowGap: '10px',
                        flexWrap: 'wrap',
                    }}
                    className="fileTask"
                >
                    {fileURL?.length > 0 && (
                        <MediaViewer mediaFiles={fileURL} isSupport={true} />
                    )}
                </Row>
            </div>
        </>
    )
}

export default SupportAttachmentSection
